export default{
    newsFourTitle: "金融科技在马来西亚达到拐点",
    newsTime: "发布时间",
    newsRead:"阅读量",
    newsFourDetail:[
        {
            p:"毋庸置疑，2020 年是动荡的一年，疫情影响了数以百万计人的生活，但是这也为马来西亚金融科技领域的快速增长提供了动力。"
        },
        {
            p:"报告说，马来西亚过去十年中一直在进行数字化转型，但疫情加速了数字化银行的采用。2020 年，网上银行和手机银行渗透率分别达到 112.5％ 和 61.8％，手机银行交易额达 4.6 亿令吉，较上年增长 125%。 "
        },
        {
            p:"马来西亚政府的“出行控制令”起到了催化剂的作用，导致去年增加了 300 万的移动银行服务用户，并将电子钱包的使用和采用推向了新高。商家们迅速接受了这一趋势，有超过 40 万家新企业注册了二维码支付服务，比上一年增长了 164％。"
        },
        {
            p:"这建立在快速发展的电子钱包行业之上，该行业拥有 40 多家非银行提供商，其中 Touch'n Go 是马来西亚最大的电子钱包，拥有 500 万用户和 30 万商户，Boost 为 880 万用户和 23.1 万多家商户提供服务，BigPay 拥有 140 万用户。"
        },
        {
            p:"在其他金融科技领域，包括电子汇款、财富技术、另类融资和加密货币交易，数字金融也在蓬勃发展。."
        },
        {
            p:"在电子汇款方面，去年总交易额增长了 106％。随着电汇的汇款额达到 265 亿令吉，电子汇款的市场份额从 14％ 增长到 25％，这表明马来西亚人正在迅速抛弃传统提供商，以寻求新的、成本更低的电子汇款提供商。"
        },

        {
            p:"Wealthtech 去年也有所增长，到 2020 年开设了超过 17.5 万个新的数字投资管理帐户。在另类融资中，在股权众筹平台上筹集的资金跃升了 457％，达到 1.277 亿令吉，而 P2P 贷款价值增长超过20%，达到 5.033 亿令吉。"
        },
        {
            p:"2020 年，为了帮助数字金融蓬勃发展，引入了许多法规变化。6 月，马来西亚国家银行发布了关于电子客户了解(eKYC)的新政策框架，以促进数字化，自 2019 年以来，马来西亚政府一直在制定国家数字身份框架。"
        },
        {
            p:"去年 12 月，马来西亚央行发布了针对数字银行的许可框架，表示到 2022 年第 1 季度最多将授予 5 张数字银行执照。"
        },
        {
            p:"截至目前，已有 40 多家企业正式表达了兴趣，并在网上提交了申请。其中包括 Boost 电子钱包、BigPay、TNG Digital 的运营商 Axiata Digital，以及 AMTD、Tyme Bank 和 Razer 等其他外国公司。"
        }

    ]
}